module.exports = __webpack_public_path__ + "np.svg?ae77ebf59438581b651dea3429584baa";